import {
    setActiveBot,
    setDataBots,
    setTelegramBotUsers,
    setUpdateBot,
    setUpdateDataBot,
} from '../../../../store/slices/integrationSlice';
import { removeUser } from '../../../../store/slices/userSlice';
import { errorToast, infoToast } from '../../../methods/toast';
import { $authHost } from '../../http';

let userId = localStorage.getItem('@storage_User_Id');

// Получение списка тг ботов
export const getIntegrationList = (id) => {
    return async (dispatch) => {
        try {
            const { data } = await $authHost.get(
                `/integrations/telegram-bot/list?userId=${id}`
            );

            if (data.code === 200) {
                dispatch(setDataBots(data.telegramBots));
                localStorage.setItem(
                    'dataBots',
                    JSON.stringify(data.telegramBots)
                );
            } else {
                errorToast('Ошибка при получении списка интеграций.');
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 401) {
                    dispatch(removeUser());
                } else if (error.response.status === 500) {
                    errorToast('Ошибка сервера. Попробуйте позже.');
                }
            } else if (error.request) {
                errorToast('Проблемы с подключением. Проверьте интернет.');
            } else {
                errorToast('Произошла неизвестная ошибка.');
            }

            console.log('getIntegrationList error: ', error);
        }
    };
};

// Создание тг бота
export const postNewBotData = (dataNewBot, userId) => {
    return async (dispatch) => {
        try {
            const { data } = await $authHost.post(
                `/integrations/telegram-bot/new`,
                dataNewBot
            );
            console.log('postNewBotData data:', data);
            if (data.code === 200) {
                dispatch(getIntegrationList(userId));
            } else {
                errorToast('Ошибка при создании бота.');
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 401) {
                    dispatch(removeUser());
                } else if (error.response.status === 500) {
                    errorToast('Ошибка сервера. Попробуйте позже.');
                }
            } else if (error.request) {
                errorToast('Проблемы с подключением. Проверьте интернет.');
            } else {
                errorToast('Произошла неизвестная ошибка.');
            }

            console.log('postNewBotData error:', error);
            dispatch(getIntegrationList(userId));
        }
    };
};

// Удаление тг бота
export const deleteBot = (id, userId) => {
    return async (dispatch) => {
        try {
            const { data } = await $authHost.delete(
                `/integrations/telegram-bot/delete?id=${id}`
            );

            if (data.code === 200) {
                dispatch(getIntegrationList(userId));
                infoToast('Бот успешно удален.');
            } else {
                errorToast('Ошибка при удалении бота.');
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 401) {
                    dispatch(removeUser());
                } else if (error.response.status === 500) {
                    errorToast('Ошибка сервера. Попробуйте позже.');
                }
            } else if (error.request) {
                errorToast('Проблемы с подключением. Проверьте интернет.');
            } else {
                errorToast('Произошла неизвестная ошибка.');
            }

            console.log('deleteBot error:', error);
            dispatch(getIntegrationList(userId));
        }
    };
};

// Получение списка пользователей тг бота
export const getTelegramBotUsersList = (id) => {
    return async (dispatch) => {
        try {
            const { data } = await $authHost.get(
                `/integrations/telegram-bot/user/list?telegramBotId=${id}`
            );

            if (data.code === 200) {
                dispatch(setTelegramBotUsers(data.telegramBotUsers));
                return data.telegramBotUsers;
            } else {
                errorToast('Ошибка получения списка пользователей бота.');
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 401) {
                    dispatch(removeUser());
                } else if (error.response.status === 500) {
                    errorToast('Ошибка сервера. Попробуйте позже.');
                }
            } else if (error.request) {
                errorToast('Проблемы с подключением. Проверьте интернет.');
            } else {
                errorToast('Произошла неизвестная ошибка.');
            }

            console.log('getTelegramBotUsersList error:', error);
            return null;
        }
    };
};

// Отправка сообщения всем пользователям тг бота
export const postAllUsersMessage = (dataMessage) => {
    return async (dispatch) => {
        try {
            const { data } = await $authHost.post(
                `/integrations/telegram-bot/send`,
                dataMessage
            );

            if (data.code === 200) {
                console.log('Сообщение успешно отправлено', data);
            } else {
                errorToast('Ошибка отправки сообщения.');
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 401) {
                    dispatch(removeUser());
                } else if (error.response.status === 500) {
                    errorToast('Ошибка сервера. Попробуйте позже.');
                }
            } else if (error.request) {
                errorToast('Проблемы с подключением. Проверьте интернет.');
            } else {
                errorToast('Произошла неизвестная ошибка.');
            }

            console.log('postAllUsersMessage error:', error);
        }
    };
};

// Отправка сообщения конкретному пользователю тг бота
export const postUserMessage = (dataMessage) => {
    return async (dispatch) => {
        try {
            const { data } = await $authHost.post(
                `/integrations/telegram-bot/user/send`,
                dataMessage
            );

            if (data.code === 200) {
                console.log('Сообщение успешно отправлено', data);
            } else {
                errorToast('Ошибка отправки сообщения.');
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 401) {
                    dispatch(removeUser());
                } else if (error.response.status === 500) {
                    errorToast('Ошибка сервера. Попробуйте позже.');
                }
            } else if (error.request) {
                errorToast('Проблемы с подключением. Проверьте интернет.');
            } else {
                errorToast('Произошла неизвестная ошибка.');
            }

            console.log('postUserMessage error:', error);
        }
    };
};

// Обновление тг бота
export const updateTgBot = (updatedData, navigate) => {
    return async (dispatch) => {
        try {
            const { data } = await $authHost.put(
                `/integrations/telegram-bot/update`,
                updatedData
            );

            if (data.code === 200) {
                dispatch(getIntegrationList(userId));
                dispatch(setActiveBot({ activeBot: data.telegramBot, i: 0 }));
                localStorage.setItem(
                    'activeBot',
                    JSON.stringify({ activeBot: data.telegramBot, i: 0 })
                );
                navigate(`/integration/telegram-bot/active/${updatedData.id}`);
                dispatch(setUpdateBot(false));
                dispatch(setUpdateDataBot(null));

                infoToast('Бот успешно обновлён!');
            } else {
                errorToast('Ошибка обновления бота.');
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 401) {
                    dispatch(removeUser());
                } else if (error.response.status === 500) {
                    errorToast('Ошибка сервера. Попробуйте позже.');
                }
            } else if (error.request) {
                errorToast('Проблемы с подключением. Проверьте интернет.');
            } else {
                errorToast('Произошла неизвестная ошибка.');
            }

            console.log('updateBot error:', error);
        }
    };
};
